export enum WordPressInstance {
  staging = 'staging',
}

export interface DebugFlagsResponseJSON {
  data: DebugFlagsJSON;
}

interface DebugFlagsJSON {
  site_id: string;
  instance: WordPressInstance;
  display: boolean;
}

export class DebugFlags {
  public constructor(public siteId: string, public instance: WordPressInstance, public display: boolean) {}

  public static fromJSON(json: DebugFlagsJSON): DebugFlags {
    return new DebugFlags(json.site_id, json.instance, json.display);
  }

  public debugEnabled(): boolean {
    return this.display;
  }
}
